export default "__VITE_ASSET__7s9vCTkg__"